import OBase from './OBase';
import * as Geometry from '../geometry';

export default class CrossProduct extends OBase {
  update () {
    let aValTree = this.getVector3Input('Vector A');
    let bValTree = this.getVector3Input('Vector B');
    let uValTree = this.getBoolInput('Unitize');

    let vOutput = this.getGenericObjectOutput('Vector');
    let lOutput = this.getGenericObjectOutput('Length');

    let dataTrees = [];
    var outDataTrees = [];
    dataTrees.push(aValTree);
    dataTrees.push(bValTree);
    dataTrees.push(uValTree);

    Geometry.makeMultiplePairs(dataTrees, outDataTrees);

    var vOutTree = new Geometry.DataTree();
    var lOutTree = new Geometry.DataTree();
    for (let i = 0; i < outDataTrees[0].branches.length; i++) {
      for (let j = 0; j < outDataTrees[0].branches[i].length; j++) {
        let aVal = outDataTrees[0].branches[i][j];
        let bVal = outDataTrees[1].branches[i][j];
        var uVal = outDataTrees[2].branches[i][j];

        var val = new THREE.Vector3();
        val.crossVectors(aVal, bVal);

        if (uVal) {
          val.normalize();
          vOutTree.add(val, outDataTrees[0].paths[i]);
          lOutTree.add(1.0, outDataTrees[0].paths[i]);
        } else {
          vOutTree.add(val, outDataTrees[0].paths[i]);
          lOutTree.add(val.length(), outDataTrees[0].paths[i]);
        }
      }
    }

    vOutput.value = vOutTree;
    lOutput.value = lOutTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/CrossProduct.js